// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../shared/material.module';
import { SharedModule } from '../shared/shared.module';
import { DealerDealRoutingModule } from './deal-container/routing/dealer-deal-routing.module';
import { DealComponent } from './deal-container/deal/deal.component';
import { DealerDealCardComponent } from './deals-container/dealer-deal-card/dealer-deal-card.component';
import { DealerDealsComponent } from './deals-container/dealer-deals/dealer-deals.component';
import { DealerFormsRoutingModule } from './forms-container/dealer-forms-routing.module';
import { FormsComponent } from './forms-container/forms/forms.component';
import { DealerHelpComponent } from './dealer-help/dealer-help.component';
import { DealerSettingsComponent } from './dealer-settings/dealer-settings.component';
import { CustomDealGroupsRoutingModule } from './custom-deal-groups-container/custom-deal-groups-routing.module';
import { EditFormComponent } from './forms-container/edit-form/edit-form.component';
import { DealerDealsRoutingModule } from './deals-container/dealer-deals-routing.module';
import { DealAddDocComponent } from './deal-container/deal-add-doc/deal-add-doc.component';
import { StartDealJacketComponent } from './deals-container/start-deal-jacket/start-deal-jacket.component';
import { DealInfoComponent } from './deal-container/deal-info/deal-info.component';
import { TemplateGroupsComponent } from './deals-container/start-deal-jacket/template-groups/template-groups.component';
import { DealTypeComponent } from './deals-container/start-deal-jacket/deal-type/deal-type.component';
import { LeadsComponent } from './leads-container/leads.component';
import { LeadDetailsComponent } from './leads-container/lead-details/lead-details.component';
import { TabSpinnerComponent } from './tab-spinner/tab-spinner.component';
import { MergedPDFComponent } from './merge-documents/merge-documents.component';
import { DealerViewComponent } from './deal-docs-container/dealer-view/dealer-view.component';
import { DealerUploadComponent } from './deal-docs-container/dealer-upload/dealer-upload.component';
import { DealerSignComponent } from './deal-docs-container/dealer-sign/dealer-sign.component';
import { DealEditDocComponent } from './deal-container/deal-edit-doc/deal-edit-doc.component';
import { CustomDealGroupsComponent } from './custom-deal-groups-container/custom-deal-groups/custom-deal-group.component';
import { DealerManagementComponent } from './dealer-management/dealer-management.component';
import { UserManagementComponent } from './user-management/user-management.component';
import { DealerEditComponent } from './dealer-management/dealer-edit/dealer-edit.component';
import { EditUserComponent } from './user-management/user-edit/user-edit.component';
import { DealAddMultipleDocsComponent } from './deal-container/deal-add-multiple-docs/deal-add-multiple-docs.component';
import { ConsumerDocumentsComponent } from './consumer-docs-container/consumer-documents/consumer-documents.component';
import { DocumentJacketComponent } from './consumer-docs-container/document-jacket/document-jacket.component';
import { DocumentStorageComponent } from './storage-container/document-storage/document-storage.component';
import { StorageJacketComponent } from './storage-container/storage-jacket/storage-jacket.component';
import { StartStorageJacketComponent } from './storage-container/start-storage-jacket/start-storage-jacket.component';
import { DocumentLibraryComponent } from './document-library/document-library/document-library.component';
import { DocumentLibraryAdminComponent } from './document-library/document-library-admin/document-library-admin.component';
import { ExpressUploadRoutingModule } from './deals-container/start-deal-jacket/express-upload-routing.module';
import { DealSendDocsComponent } from './deal-container/deal-send-docs/deal-send-docs.component';
import { EditEnrollmentsComponent } from './dealer-management/edit-enrollments/edit-enrollments.component';
import { NotarizeDocumentsComponent } from './deal-container/notarization/notarize-documents/notarize-documents.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { TestDriveAdminComponent } from './dealer-management/test-drive-admin/test-drive-admin.component';
import { MatSortModule } from '@angular/material/sort';

@NgModule({
    declarations: [
        DealAddDocComponent,
        DealerDealsComponent,
        DealComponent,
        DealInfoComponent,
        DealerDealCardComponent,
        DealerHelpComponent,
        DealerManagementComponent,
        DealerEditComponent,
        DealerSettingsComponent,
        DealerViewComponent,
        DealerUploadComponent,
        DealerSignComponent,
        DealEditDocComponent,
        EditFormComponent,
        FormsComponent,
        StartDealJacketComponent,
        TemplateGroupsComponent,
        DealTypeComponent,
        LeadsComponent,
        LeadDetailsComponent,
        CustomDealGroupsComponent,
        TabSpinnerComponent,
        MergedPDFComponent,
        UserManagementComponent,
        EditUserComponent,
        DealAddMultipleDocsComponent,
        ConsumerDocumentsComponent,
        DocumentJacketComponent,
        DocumentStorageComponent,
        StorageJacketComponent,
        StartStorageJacketComponent,
        DocumentLibraryAdminComponent,
        DocumentLibraryComponent,
        DealSendDocsComponent,
        EditEnrollmentsComponent,
        NotarizeDocumentsComponent,
        DashboardComponent,
        TestDriveAdminComponent,
    ],
    imports: [
        CommonModule,
        DealerDealRoutingModule,
        DealerDealsRoutingModule,
        ExpressUploadRoutingModule,
        CustomDealGroupsRoutingModule,
        DealerFormsRoutingModule,
        FormsModule,
        MaterialModule,
        ReactiveFormsModule,
        SharedModule,
        MatSortModule,
    ],
    exports: [DealerHelpComponent, DealerDealCardComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DealerModule {}
